import { sendRequest } from './index';
import { API_COMMON_URL } from '@core/constants/API';

export const CourseSuggestionService = (payload) => {
    return sendRequest({
        url: `${API_COMMON_URL}course-suggestions`,
        method: 'POST',
        body: payload
    });
};

export const FinancialSupportService = (payload) => {
    return sendRequest({
        url: `${API_COMMON_URL}financial-support`,
        method: 'POST',
        body: payload
    });
};